module.exports = __webpack_public_path__ + "img/reading-book.03b9cb9a.svg";